import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    SettingsUsersFormCard,
    SettingsUsersFormFeedback,
    SettingsUsersFormFields,
} from './components/settings-users-form/components';
import { useSettingsUsersCreateForm } from './components/settings-users-form/hooks';

export const SettingsUsersCreateScreen = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    const {
        form,
        isSaving,
        error,
        successMessage,
        handleInputChange,
        handleSubmit,
    } = useSettingsUsersCreateForm({ token });

    return (
        <SettingsUsersFormCard
            title="Crear usuario"
            onBack={() => navigate('/settings/users')}
        >
            <p className="text-muted mb-4">
                Solo se registran los datos principales. El usuario recibirá un correo para activar su cuenta y definir su contraseña.
            </p>

            <SettingsUsersFormFeedback error={error} successMessage={successMessage} />

            <form onSubmit={handleSubmit}>
                <SettingsUsersFormFields
                    form={form}
                    onInputChange={handleInputChange}
                />

                <div className="mt-4 d-flex gap-2">
                    <button type="submit" className="btn btn-primary" disabled={isSaving}>
                        {isSaving ? 'Creando...' : 'Crear y enviar activación'}
                    </button>
                    <button type="button" className="btn btn-light-brand" onClick={() => navigate('/settings/users')}>
                        Cancelar
                    </button>
                </div>
            </form>
        </SettingsUsersFormCard>
    );
};
